/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: block;
}

.header {
  display: flex;
  justify-content: space-between;
  padding-block: 0px;
  padding-inline: 0.25rem;
}

:host([scale=s]) .text {
  margin-block: 0.5rem;
  font-size: var(--calcite-font-size--1);
  line-height: 1rem;
}
:host([scale=s]) .chevron {
  block-size: 2.25rem;
}

:host([scale=m]) .text {
  margin-block: 0.75rem;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
}
:host([scale=m]) .chevron {
  block-size: 3rem;
}

:host([scale=l]) .text {
  margin-block: 1rem;
  font-size: var(--calcite-font-size-1);
  line-height: 1.5rem;
}
:host([scale=l]) .chevron {
  block-size: 3.5rem;
}

.chevron {
  margin-inline: -0.25rem;
  box-sizing: content-box;
  display: flex;
  flex-grow: 0;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-style: none;
  background-color: var(--calcite-color-foreground-1);
  padding-inline: 0.25rem;
  color: var(--calcite-color-text-3);
  outline: 2px solid transparent;
  outline-offset: 2px;
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  inline-size: 14.2857142857%;
}
.chevron:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.chevron:hover, .chevron:focus {
  background-color: var(--calcite-color-foreground-2);
  fill: var(--calcite-color-text-1);
  color: var(--calcite-color-text-1);
}
.chevron:active {
  background-color: var(--calcite-color-foreground-3);
}
.chevron[aria-disabled=true] {
  pointer-events: none;
  opacity: 0;
}

.text {
  margin-block: auto;
  display: flex;
  inline-size: 100%;
  flex: 1 1 auto;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1;
}

.text--reverse {
  flex-direction: row-reverse;
}

.month,
.year,
.suffix {
  margin-inline: 0.25rem;
  margin-block: auto;
  display: inline-block;
  background-color: var(--calcite-color-foreground-1);
  font-weight: var(--calcite-font-weight-medium);
  line-height: 1.25;
  color: var(--calcite-color-text-1);
  font-size: inherit;
}

.year {
  position: relative;
  inline-size: 2.5rem;
  border-style: none;
  background-color: transparent;
  text-align: center;
  font-family: inherit;
  outline-color: transparent;
}
.year:hover {
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-property: outline-color;
  outline: 2px solid var(--calcite-color-border-2);
  outline-offset: 2px;
}
.year:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}

.year--suffix {
  text-align: start;
}

.year-wrap {
  position: relative;
}

.suffix {
  inset-block-start: 0px;
  white-space: nowrap;
  text-align: start;
  inset-inline-start: 0;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}